module.exports = __webpack_public_path__ + "static/media/check.1dbf5c03.svg";